
import Vue from "vue";
import filters from '@/filters';
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
  },
  filters,
})
export default class ModalWebinarTerms extends Vue {
  /* STATE */
  @State("locale")
  private locale: any;

  @Prop({default: false})
  private isShow: boolean;
  @Prop({default: () => {}})
  private submit: () => {};

  private reset() {
    this.$emit('close');
  }
}
